import React from 'react'
import DistrictTitleTopic from '../../../../components/TitleTopic/_views/DistrictTitleTopic'

const BlockDistrictTitleTopic = ({ data: { title, identifier } = {}, data, ...props }) => (
  <DistrictTitleTopic view="screen" title={title} district={identifier} {...props} />
)

export default BlockDistrictTitleTopic
